/* global I18n */
import React from "react";
import Story from "./story";
import Entity from "../Entity";
import { sendAnalyticsEvent } from "../../utils/helpers";

class NewsroomStory extends Story {
  constructor (props) {
    super(props);

    this.state = {
      story: props.story,
      entity: props.story.entity,
      payload: props.story.payload
    };
    this.article = {}; // to store the parsed article
    this.parseArticle();
    this.gaEvents = {
      type: "event",
      category: "myFeed",
      action: "click"
    };
  }

  parseArticle () {
    this.article.title = this.props.story.payload[0].data;
    this.article.url = this.props.story.payload[0].url;
    this.article.featured_image = this.props.story.payload[0].image.medium;
    this.article.publication_date = this.props.story.payload[1].data;

    if (this.article.featured_image) {
      this.article.featured_image = this.article.featured_image.replace("medium_jpg", "newsletter");
    }
  }

  render () {
    const tracking = "?ad_medium=myad_feed&ad_name=newsroom-story";
    const subtitleMsg = I18n.t("jslibrary.stream.because_follow");
    const saveMsg = I18n.t("jslibrary.save");
    return (
      <div
        className="myad-story"
        data-insights-category="myad-feed"
        data-insights-label="article-story"
        data-insights-value={this.article.url}
      >
        <header className="myad-story__header">
          <h2 className="myad-story__title">
            <a
              className="afd-title--black-link"
              href={this.article.url + tracking}
              onClick={() => sendAnalyticsEvent({ ...this.gaEvents })}
            >
              {this.article.title}
            </a>
          </h2>
          <div className="myad-story__metadata date-publication">
            <div className="myad-story__metadata-date">
              <p>{this.formatDate(this.article.publication_date)} | {subtitleMsg} </p>
              <Entity entity={this.state.entity} />
            </div>

            <div className="myad-story__metadata-single-bookmark afd-desktop-e">
              <a
                href={this.article.url + tracking}
                className="afd-icon-text afd-save-item clearfix myarchdaily-multiple-fav"
                data-image={this.article.featured_image}
                data-title={this.article.title}
                data-message={saveMsg}
                data-url={this.article.url}
              >
                <i className="afd-icon-text__icon afd-icon afd-icon--icon-folder-white" />
                <span className="afd-fl">
                  {saveMsg}
                </span>
              </a>
            </div>
          </div>
        </header>

        <div className="myad-story__content">
          <figure>
            <a href={this.article.url} onClick={() => sendAnalyticsEvent({ ...this.gaEvents })}>
              <img src={this.article.featured_image} alt={this.article.title} height="400" />
            </a>
          </figure>
        </div>
      </div>
    );
  }
}

export default NewsroomStory;
